import { render, staticRenderFns } from "./campaign-details.vue?vue&type=template&id=16d3fd02"
import script from "./campaign-details.vue?vue&type=script&lang=js"
export * from "./campaign-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports